import React from 'react';
import { connect } from 'react-redux';

const Account = (props) => {
  return <div><h1>Account</h1></div>;
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Account);
